import React from 'react';
import { ArrowUpRight } from 'lucide-react';

const HirededicatedBIMmodelers = () => {
    return (
        <section className="hire-dedicated-section">
            <div className="hire-dedicated-container">
                {/* Left Side Content */}
                <div className="hire-dedicated-content">
                    <h2 className="dedicated-title">
                        <span className="text-primary">Hire dedicated BIM modelers and</span> <br />
                        architects invested in your success.
                    </h2>
                    <p className="dedicated-subtitle">
                        Our specialized teams collaborate with you to deliver optimal results.
                    </p>
                    <button className="contact-btn">
                        Contact US <ArrowUpRight size={20} />
                    </button>
                </div>

                {/* Right Side Visuals */}
                <div className="hire-dedicated-visual">
                    <div className="floating-elements">
                        {/* Decorative Circles */}
                        <div className="circle circle-top"></div>
                        <div className="circle circle-bottom"></div>

                        {/* Profile Cards */}
                        <div className="profile-card card-mayur">
                            <div className="profile-img-placeholder"></div>
                            <div className="profile-info">
                                <h4>Mayur Panchal</h4>
                                <p>Business development <br /> Manager</p>
                            </div>
                        </div>

                        <div className="profile-card card-mahendra">
                            <div className="profile-img-placeholder"></div>
                            <div className="profile-info">
                                <h4>Mahendra Sodha</h4>
                                <p>Sales Executive</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default HirededicatedBIMmodelers;
